import { AccessorsMutatorsDecorator, Model } from "../../helpers";

/**
 * @class ZatcaApiLog
 *
 * @property {number} id
 */
export class ZatcaApiLog extends Model {


}

AccessorsMutatorsDecorator(
  "id",
  "property_id",
  "reservation_id",
  "reservation_invoice_id",
  "reservation_invoice_credit_note_id",
  "is_success",
  "api_type",
  "api_response",
  "transaction_type",
  "document_type",
  "invoice_number",
  "zatca_uuid",
  "endpoint_url",
  "http_status_code",
  "request_date",
  "request_payload",
  "response_date",
  "response_payload",
  "error_message",
  "warning_messages",
  "retry_count",
  "original_log_id",
  "created_at",
  "updated_at",
  "reservation",
  "reservation_invoice",
  "credit_note",
  "reservation_ident"
)(ZatcaApiLog);



// WEBPACK FOOTER //
// ./src/pms-api/models/zatca-api-log.model.js